import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';

import formatPrice from 'utils/formatPrice';
import pxToEm from 'styles/pxToEm';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    maxWidth: '100%',
  },
  label: {
    display: 'inline-block',
    position: 'relative',
    marginBottom: -6,
    marginLeft: 4,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
    whiteSpace: 'nowrap',
  },
  typography: {
    padding: '11px 0 10px 0',
    lineHeight: pxToEm(16, 14),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const ProductClaimTotalChargeFields = ({ name, classes, ...fields }) => {
  const units = get(fields, `${name}.Units`).input.value;
  const caloriesPerUnit = get(fields, `${name}.Calories Per Unit`);
  const charge = Number(get(fields, `${name}.Charge`).input.value.replace(/[$,]/g, ''));
  const calculatedUnits = caloriesPerUnit && caloriesPerUnit.input.value && units
    ? Math.ceil(units * caloriesPerUnit.input.value / 100) : units;
  let totalCharge = calculatedUnits && charge ? calculatedUnits * charge : null;
  if (totalCharge && Math.round(totalCharge) !== totalCharge) {
    totalCharge = totalCharge.toFixed(2);
  }
  return (
    <div className={classes.root}>
      <InputLabel
        className={classes.label}
        disableAnimation
        shrink={false}
      >
        Total
      </InputLabel>
      {totalCharge &&
        <Typography className={classes.typography}>
          {formatPrice(totalCharge)}
        </Typography>
      }
    </div>
  );
};

ProductClaimTotalChargeFields.propTypes = {
  name: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProductClaimTotalChargeFields);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimTotalChargeFields.js